<template>
  <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content">
    <div class="modal-header">
      <h5 class="modal__title text-white">Manage Policy Groups</h5>
      <button type="button" class="btn-close" @click="close" aria-label="Close"></button>
    </div>
    <div class="modal__content">
      <div class="modal__body">
        <div class="row">
          <div class="col-md-6">
            <h6>Existing Groups</h6>
            <ul v-if="groups.length" class="list-group">
              <li v-for="group in groups" :key="group.ID" class="list-group-item d-flex justify-content-between align-items-center">
                <span>{{ group.name }}</span>
                <div class="btn-group">
                  <button class="btn btn-sm btn-outline-primary" @click="editGroup(group)">Edit</button>
                  <button class="btn btn-sm btn-outline-danger" @click="handleDelete(group.ID)">Delete</button>
                </div>
              </li>
            </ul>
            <div v-else class="text-muted">
              No policy groups found.
            </div>
          </div>

          <div class="col-md-6 border-start">
            <h6>{{ isEditing ? 'Edit Group' : 'Add New Group' }}</h6>
            <form @submit.prevent="handleSubmit">
              <div class="mb-3">
                <label for="groupName" class="form-label">Group Name</label>
                <span class="asterisk-required">*</span>
                <input type="text" class="form-control" id="groupName" v-model="editableGroup.name" required>
              </div>
              <div class="mb-3">
                <label for="groupDescription" class="form-label">Description</label>
                <span class="asterisk-required">*</span>
                <textarea class="form-control" id="groupDescription" rows="4" v-model="editableGroup.description" required></textarea>
              </div>
              <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-secondary me-2" @click="clearForm">Clear Fields</button>
                <button type="submit" class="btn btn-primary">{{ isEditing ? 'Update Group' : 'Add Group' }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>
export default {
  name: "PolicyGroupsManager",
  props: {
    modelValue: { type: Boolean, required: true },
    groups: { type: Array, required: true },
  },
  emits: ['update:modelValue', 'create-group', 'update-group', 'delete-group'],
  data() {
    return {
      isEditing: false,
      editableGroup: {
        ID: null,
        name: '',
        description: '',
      }
    }
  },
  computed: {
    showModal: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },
  watch: {
    modelValue(newValue) {
      // If the modal is being closed, clear the form.
      if (!newValue) {
        this.clearForm();
      }
    }
  },
  methods: {
    close() {
      this.clearForm(); // Reset the form
      this.showModal = false; // Close the modal
    },
    clearForm() {
      this.isEditing = false;
      this.editableGroup = { ID: null, name: '', description: '' };
    },
    editGroup(group) {
      this.isEditing = true;
      this.editableGroup = { ...group };
    },
    handleDelete(groupId) {
      if (confirm('Are you sure you want to delete this group? This would not delete the policies inside the group. This action cannot be undone.')) {
        this.$emit('delete-group', groupId);
      }
    },
    handleSubmit() {
      if (!this.editableGroup.name || !this.editableGroup.description) {
        alert('Group Name and Description are required.');
        return;
      }
      if (this.isEditing) {
        this.$emit('update-group', this.editableGroup);
      } else {
        const { name, description } = this.editableGroup;
        this.$emit('create-group', { name, description });
      }
      // We still clear the form on successful submission
      this.clearForm();
    }
  }
}
</script>
<style scoped>
:deep(.modal-content) {
  max-height: 90%;
  width: 60% !important;
}

.modal__action {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-shrink: 0;
  padding: 1rem 0 0;
}

</style>